import { components } from "@/api-schema";
import { Action } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { BrandTable } from "@/components/data-table/predefined/brand-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BrandMergeDialog } from "./_components/brand-merge-dialog";

type Brand = components["schemas"]["Brand"];

const DEFAULT_PAGE_SIZE = 100;

export function BrandView() {
  const { t } = useTranslation(["common", "ram"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "Brand");
  const canMerge = ability.can(Action.Merge, "Brand");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
        showRestore: false,
      };

  const [mergingBrand, setMergingBrand] = useState<Brand | null>(null);

  return (
    <Can I="read" a="Brand">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("ram:Brands")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <BrandTable
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onMerge={canMerge ? (brand) => setMergingBrand(brand) : undefined}
        />
      </CenteredLayout>

      {mergingBrand && (
        <BrandMergeDialog
          open={true}
          source={{
            uuid: mergingBrand.uuid ?? "",
            label: mergingBrand.name ?? "",
          }}
          sourceLogoUrl={mergingBrand.logoUrl}
          onClose={() => setMergingBrand(null)}
        />
      )}
    </Can>
  );
}
